export default {
    issues: {
        title: "Todas las incidencias",
        subtitle: "{{count}} incidencia en todos los contenedores",
        subtitle_plural: "{{count}} incidencias en todos los contenedores",
        intro:
            "Esta es tu cola de excepciones operativas: problemas estructurados ligados a contenedores o documentos (documentos faltantes, comprobaciones, retrasos y más).",
        bulletTiles:
            "Los resúmenes superiores filtran la tabla por categorías habituales (documentos faltantes, comprobaciones simples, cruzadas, otras).",
        bulletFilters:
            "La barra de filtros permite gravedad, estado, categoría, tipo, búsqueda, solo bloqueantes, incidencias resueltas y rango de fechas (ETA/ETD del contenedor — ver el icono de información junto a las fechas).",
        bulletTable: "Haz clic en una fila para abrir el envío con la pestaña Incidencias y actuar con todo el contexto.",
        reviewContrast:
            "Las confirmaciones humanas (identificación, asignación de documentos) están en el <reviewLink>Centro de revisión</reviewLink> — distinto de esta lista de incidencias operativas.",
    },
    reviewCenter: {
        sidebarListTitle: "Elementos n. {{count}}",
        sidebarListTitleLoading: "Elementos",
        title: "Centro de revisión",
        intro:
            "Una cola breve donde el sistema necesita una decisión humana antes de fiarse de los datos: identificación de contenedor, asignación de documentos, comprobaciones de seguimiento y confirmaciones similares. Revisarla con frecuencia mantiene fiable la automatización posterior.",
        step1: "Elige un contenedor de la lista de la izquierda (los pendientes están resaltados).",
        step2: "En Identificación verifica o edita campos, responde a preguntas del agente si aparecen, luego resuelve o descarta.",
        step3: "En Documentos conserva, reclasifica, elimina o mueve documentos; fusiona duplicados cuando se sugiera.",
        step4: "Abre correos o vistas previas de documentos desde el panel de detalle cuando necesites el contexto de origen.",
        vsIssues:
            "Para problemas operativos estructurados en envíos y documentos, usa <issuesLink>Incidencias</issuesLink>.",
    },
};
